export default "__VITE_ASSET__9dbd9d60__"